const styles = theme => ({
    root: {
      gridColumnStart: 2,
      padding: theme.spacing(5, 0),
    },

    '& .Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#b5b5b5',
    },
  
  })
  
  export default styles
  